
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitopimprichichwad() {



    const cardData =
    {
        keyword: 'Mumbai to Pimpri Chinchwad Cab',
        heading: 'Skyline Cabs: Mumbai to Pimpri Chinchwad Cab ',
        headingDescription: 'Skyline Cabs offers reliable and comfortable Mumbai to Pimpri Chinchwad Cab services for all your travel needs. Whether you are heading home, traveling for business, or visiting family, our professional drivers and clean, well-maintained vehicles ensure a smooth and hassle-free journey. Enjoy timely pickups, transparent pricing, and 24/7 customer support with every ride. Book your Mumbai to Pimpri Chinchwad cab with Skyline Cabs and travel in comfort and peace of mind.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Mumbai to Pimpri Chinchwad Cab",
      "description": "Skyline Cabs offers reliable and comfortable cab services from Mumbai to Pimpri Chinchwad. Whether you're traveling for work, visiting family, or heading home, our fleet of well-maintained vehicles ensures a safe and pleasant journey."
    },
    {
      "name": "Mumbai to Pimpri Akurdi Cab",
      "description": "Book a cab from Mumbai to Pimpri Akurdi with Skyline Cabs for a smooth and stress-free ride. Choose from a wide range of vehicles including sedans, Ertiga, and Innova Crysta for one-way or round-trip travel."
    },
    {
      "name": "Mumbai Airport to Pimpri Chinchwad",
      "description": "Skyline Cabs provides timely pickups from Mumbai Airport to Pimpri Chinchwad. Enjoy airport transfers with courteous drivers, sanitized cars, and GPS-enabled vehicles—available for domestic and international terminals."
    },
    {
      "name": "Mumbai to Pimpri Chinchwad One Way Cab",
      "description": "Need a one-way cab from Mumbai to Pimpri Chinchwad? Skyline Cabs offers budget-friendly options with door-to-door service, on-time pickups, and multiple car categories to suit your travel needs."
    },
    {
      "name": "Mumbai to Pimpri Chinchwad Taxi Fare",
      "description": "Get transparent and competitive taxi fare for Mumbai to Pimpri Chinchwad rides with Skyline Cabs. All fares include tolls, taxes, fuel, and driver charges—no hidden costs guaranteed."
    },
    {
      "name": "Dadar to Pimpri Chinchwad Cab",
      "description": "Travel from Dadar to Pimpri Chinchwad with Skyline Cabs’ premium taxi services. Our experienced drivers ensure a safe, comfortable journey with well-maintained cabs and real-time tracking for peace of mind."
    },
    {
      "name": "Andheri to Pimpri Chinchwad Cab",
      "description": "Book a cab from Andheri to Pimpri Chinchwad for a hassle-free journey. Skyline Cabs provides reliable service with flexible timing, comfortable vehicles, and 24/7 customer support."
    },
    {
      "name": "Mumbai to Pimpri Chinchwad Innova Cab",
      "description": "Enjoy spacious and luxurious travel with an Innova Crysta from Mumbai to Pimpri Chinchwad. Perfect for families and small groups, this premium cab ensures comfort and safety all the way."
    },
    {
      "name": "Mumbai to Pimpri Chinchwad Ertiga Cab",
      "description": "For an economical yet comfortable option, choose an Ertiga cab from Mumbai to Pimpri Chinchwad. Skyline Cabs provides clean, AC vehicles with trained drivers and flexible booking options."
    },
    {
      "name": "Mumbai to Baner Cab",
      "description": "Skyline Cabs offers direct cab service from Mumbai to Baner in Pune. Choose from a variety of vehicles including sedans, SUVs, and MPVs with door-to-door pickup and drop service."
    },
    {
      "name": "Mumbai to Wakad Cab",
      "description": "Book a cab from Mumbai to Wakad with Skyline Cabs for comfortable and quick transfers. Ideal for professionals, students, or families heading to Pune’s IT hub and residential zones."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Fare",
      "description": "Skyline Cabs provides transparent fare options for taxis from Mumbai Airport to Pune. Choose one-way or round-trip services with upfront pricing for Ertiga, Innova, or sedan vehicles."
    },
    {
      "name": "Mumbai to Akurdi Cab",
      "description": "Travel from Mumbai to Akurdi with Skyline Cabs’ efficient and safe cab service. Whether you’re heading to work or visiting friends, enjoy smooth rides with courteous drivers and flexible travel options."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Looking to travel from Mumbai to Pune? Skyline Cabs offers quick and easy booking with multiple vehicle choices, affordable rates, and 24/7 availability for both airport and city pickups."
    },
    {
      "name": "Taxi Services in Mumbai Central Station",
      "description": "Skyline Cabs offers pickup and drop taxi services from Mumbai Central Station to Pune and surrounding areas. Book in advance or on-demand with guaranteed safety, comfort, and reliability."
    },
    {
      "name": "Best Cabs in Pune",
      "description": "Skyline Cabs is recognized as one of the best cab services in Pune, offering local, outstation, and airport travel with a wide fleet of sedans, SUVs, and premium vehicles. Available 24/7 with trained drivers and real-time tracking."
    }
  ],
  "tableData": [
    ["Mumbai to Pimpri Chinchwad Cab", "Mumbai to Pimpri Akurdi Cab"],
    ["Mumbai Airport to Pimpri Chinchwad", "Mumbai to Pimpri Chinchwad One Way Cab"],
    ["Mumbai to Pimpri Chinchwad Taxi Fare", "Dadar to Pimpri Chinchwad Cab"],
    ["Andheri to Pimpri Chinchwad Cab", "Mumbai to Pimpri Chinchwad Innova Cab"],
    ["Mumbai to Pimpri Chinchwad Ertiga Cab", "Mumbai to Baner Cab"],
    ["Mumbai to Wakad Cab", "Mumbai Airport to Pune Taxi Fare"],
    ["Mumbai to Akurdi Cab", "Mumbai to Pune Cab Booking"],
    ["Taxi Services in Mumbai Central Station", "Best Cabs in Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Mumbai to Pimpri Chinchwad Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers timely and dependable cab services from Mumbai to Pimpri Chinchwad. Whether you’re traveling for business, leisure, or family visits, our prompt service ensures a smooth, hassle-free journey every time, without the stress of delayed pickups or uncertain routes."
    },
    {
        "WhyChooseheading": "Comfortable, Air-Conditioned Vehicles",
        "WhyChoosedescription": "Travel comfortably in our clean, well-maintained, and air-conditioned vehicles. From sedans to SUVs, each vehicle in our fleet is designed for a smooth and relaxing ride, providing ample space for both passengers and luggage during your Mumbai to Pimpri Chinchwad journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our professional, background-verified drivers are highly experienced and know the most efficient routes from Mumbai to Pimpri Chinchwad. They are committed to providing a safe, smooth, and pleasant travel experience with a focus on your comfort and well-being."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers transparent and competitive pricing for Mumbai to Pimpri Chinchwad travel. You’ll always know the cost upfront—no hidden fees or surprises, ensuring a cost-effective ride with premium service. Whether one-way or round-trip, we offer the best value."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Skyline Cabs operates 24/7 to accommodate your travel needs at any time. Whether you need an early morning ride or a late-night departure from Mumbai, we’re always ready to take you to Pimpri Chinchwad with convenience and professionalism."
    },
    {
        "WhyChooseheading": "Variety of Vehicles for Every Need",
        "WhyChoosedescription": "From solo travelers to families or corporate groups, we have a vehicle to suit your needs. Choose from our fleet of well-maintained sedans, spacious SUVs, or even luxury vehicles, ensuring your ride is comfortable and meets your budget and preference."
    },
    {
        "WhyChooseheading": "Simple and Fast Online Booking",
        "WhyChoosedescription": "Booking your Mumbai to Pimpri Chinchwad cab is simple and quick. Use our website or mobile app for easy booking, and get instant confirmation. You can also track your driver in real time and make digital payments, ensuring a smooth and modern travel experience."
    },
    {
        "WhyChooseheading": "Safe and Secure Journey",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are GPS-enabled, regularly sanitized, and driven by professional, background-checked drivers. You can rest assured that your ride from Mumbai to Pimpri Chinchwad is secure and well-maintained at every step."
    }
]




















    }


    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Mumbai to Pimpri Chinchwad with Skyline Cabs?',
            answer:
                'Booking your cab is simple with Skyline Cabs. Just visit our website or use our mobile app, enter Mumbai as your pickup location and Pimpri Chinchwad as your destination, select your preferred car, and confirm your booking instantly.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for the Mumbai to Pimpri Chinchwad route?',
            answer:
                'We offer a variety of well-maintained vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and premium cars. You can choose based on your group size and comfort requirements.',
        },
        {
            id: 3,
            question: 'Are the fares from Mumbai to Pimpri Chinchwad fixed?',
            answer:
                'Yes, the pricing is fixed and fully transparent. The fare includes toll charges, driver fees, and taxes. No hidden costs — what you see is what you pay.',
        },
        {
            id: 4,
            question: 'How long does it take to travel from Mumbai to Pimpri Chinchwad?',
            answer:
                'The journey generally takes around 3.5 to 4.5 hours depending on traffic conditions. Our experienced drivers ensure you take the best route for a smooth and timely trip.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Mumbai to Pimpri Chinchwad?',
            answer:
                'Yes, you can easily book a round-trip cab. Just provide your return date and time, and we will arrange the cab accordingly for a seamless round-trip experience.',
        },
        {
            id: 6,
            question: 'Can I get a cab from Mumbai Airport to Pimpri Chinchwad?',
            answer:
                'Yes, Skyline Cabs offers pickups from Mumbai Airport. Our drivers will be waiting for you at the arrival gate, ready to drive you safely to Pimpri Chinchwad.',
        },
        {
            id: 7,
            question: 'Are your drivers experienced and professional?',
            answer:
                'Yes, all our drivers are professional, background-verified, and well-trained for long-distance travel. They prioritize your comfort and safety during the entire journey.',
        },
        {
            id: 8,
            question: 'Can I book a cab at any time of day or night from Mumbai?',
            answer:
                'Yes, Skyline Cabs operates 24/7. Whether it’s an early morning trip or a late-night ride, our cabs are ready to pick you up anytime.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Mumbai to Pimpri Chinchwad booking?',
            answer:
                'Yes, you can easily cancel or reschedule your booking through our app, website, or by contacting customer support. We offer flexible policies to suit your plans.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Mumbai to Pimpri Chinchwad journey?',
            answer:
                'Skyline Cabs ensures a comfortable, safe, and punctual ride. Our well-maintained vehicles, trained drivers, transparent pricing, and excellent customer service make us the best choice for your Mumbai to Pimpri Chinchwad journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Vikram Joshi",
            rating: 5,
            review: "I traveled from Mumbai to Pimpri Chinchwad with Skyline Cabs and the experience was fantastic. The driver was punctual, professional, and the car was clean and comfortable. Highly recommend for long-distance travel!"
        },
        {
            name: "Miss. Riya Sharma",
            rating: 4,
            review: "The ride from Mumbai to Pimpri Chinchwad was smooth and comfortable. The driver was polite and the car was well-maintained. Just a slight delay in arrival, but otherwise, the experience was top-notch!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cabs",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-pimpri-chinchwad-cab.jpg",
  "description": "Book Mumbai to Pimpri Chinchwad cabs with Skyline Cabs for a reliable and budget-friendly ride. Choose from AC sedans or SUVs with verified drivers — available 24/7 for one-way or round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7583"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-pimpri-chinchwad-cabs"
  }
};


      
     
      


    return (
        <div>
<Helmet>
  <title>Mumbai to Pimpri Chinchwad Cabs | AC Taxi at Affordable Fare | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Pimpri Chinchwad cabs with Skyline Cabs for a reliable and budget-friendly ride. Choose from AC sedans or SUVs with verified drivers — available 24/7 for one-way or round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Pimpri Chinchwad Cabs, Cab from Mumbai to Pimpri Chinchwad, One-Way Taxi Mumbai to PCMC, Round Trip Cab Mumbai to Pimpri, AC Cab Mumbai to Pimpri Chinchwad, SUV Taxi Mumbai to PCMC, 24/7 Cab Mumbai to Pimpri Chinchwad, Skyline Cabs Mumbai to PCMC, Affordable Taxi Mumbai to Pimpri Chinchwad, Online Cab Booking Mumbai to Pimpri" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitopimprichichwad;